// extracted by mini-css-extract-plugin
module.exports = {"container":"Dashboard_container__3GPME","title":"Dashboard_title__26Riw","dashboardSection":"Dashboard_dashboardSection__xvO7L"};